export const tableStyles = ({ palette = {} }) => ({
  '& .merchant-center-grid-page': {
    overflow: 'inherit !important',
  },
  '& .toolbar-container': {
    '& .navbar-nav': {
      margin: '0px',
      height: '56px',
    },
  },
  '& #button-create': {
    '& .iconba-Add': {
      marginLeft: '0px',
      marginRight: '8px',
    },
  },
  '& .menu-item-tag': {
    backgroundColor: '#D83B01',
    color: palette.white,
    borderRadius: 12,
    padding: '0 9px',
    border: `1px solid ${palette.white}`,
    fontSize: 12,
    fontWeight: 'normal',
    height: 20,
    lineHeight: '15px',
    boxShadow: `0 2px 5px ${palette.neutralTertiary}`,
    whiteSpace: 'nowrap',
  },
  '& .merchant-center-grid-container': {
    width: '100% !important',
    '& .bingadsgrid': {
      paddingLeft: '16px',
    },
    '& .table-container': {
      '& table.table thead.header tr th.column-header': {
        verticalAlign: 'top',
        padding: '14px 8px',
      },
      '& table.table tbody tr td': {
        verticalAlign: 'top',
        padding: '14px 8px',
        'word-wrap': 'break-word',
        'word-break': 'break-word',
      },
      '& input[type="checkbox"]': {
        marginTop: '0px',
        marginLeft: '8px',
      },
    },
    '& .grid-noresult .placeholder': {
      'font-size': '14px',
      'line-height': '20px',
      color: '#323130',
    },
  },
});
